// src/pages/Login.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation } from 'react-router-dom';

export default function Login({ onLogin }) {
  const navigate = useNavigate();
  const location = useLocation();

  const API = process.env.REACT_APP_API_URL || 'https://vartasocial.com/api';

  // ✅ Get message from signup
  const signupMessage = location.state?.message || '';

  // If already logged in, bounce to home
  useEffect(() => {
    const t = localStorage.getItem('token');
    if (t) navigate('/', { replace: true });
  }, [navigate]);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');

    try {
      const r = await axios.post(
        `${API}/login`,
        { email, password },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (r.data?.token) {
        localStorage.setItem('token', r.data.token);

        if (r.data.user) {
          localStorage.setItem('user', JSON.stringify(r.data.user));
        }

        if (typeof onLogin === 'function') {
          onLogin(r.data.token, r.data.user || null);
        }

        navigate("/", { replace: true });

      } else {
        setErr('Login failed');
      }

    } catch (e2) {
      const status = e2?.response?.status;
      const msg = e2?.response?.data?.error || e2.message || 'Login error';

      if (status === 403) {
        setErr("Please confirm your email before logging in.");

        try {
          await axios.post(`${API}/send-confirm`, { email });
          alert("Confirmation email sent. Please check your inbox.");
        } catch {}

        return;
      }

      setErr(msg);
    }
  };

  return (
    <div style={{ maxWidth: 480, margin: '40px auto', padding: 12 }}>
      <h2>Login</h2>

      {/* ✅ Show signup success message */}
      {signupMessage && (
        <div style={{ color: 'green', marginBottom: 10 }}>
          {signupMessage}
        </div>
      )}

      <form onSubmit={submit}>
        <label>Email</label>
        <input
          value={email}
          onChange={e => setEmail(e.target.value)}
          type="email"
          required
          style={{ width: '100%', marginBottom: 12 }}
        />

        <label>Password</label>
        <input
          value={password}
          onChange={e => setPassword(e.target.value)}
          type="password"
          required
          style={{ width: '100%', marginBottom: 12 }}
        />

        <div style={{ marginBottom: 12 }}>
          <Link to="/forgot-password" style={{ fontSize: 14 }}>
            Forgot password?
          </Link>
        </div>

        {err && (
          <div style={{ color: 'crimson', marginBottom: 10 }}>
            {err}
          </div>
        )}

        <button type="submit" style={{ width: '100%', padding: 10 }}>
          Login
        </button>
      </form>

      <p style={{ marginTop: 14 }}>
        New here? <Link to="/signup">Create an account</Link>
      </p>
    </div>
  );
}